import React from 'react';
import { STDStyle } from '../style';
import Std from '../../stdPages/std';
import Text from '@/components/Text';
import * as w from '@/helpers_site/textsSite';


const P404 = () => {
  return (
    <Std withoutMenu={true}>
      <STDStyle>
        <Text title={w.P404_title} $family='Head' color={'rgb(0,14,38)'} typeFont='head' tag='h1' />
      </STDStyle>
    </Std>
  );
};

export default P404;
